export enum UserRole {
	ADMIN = "Admin",
	USER = "User",
	MANDANT_ADMIN = "MandantAdmin",
}